/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import { I18n } from '@aws-amplify/core';
import { Translations } from '@aws-amplify/ui-components';
import { AmplifySignUp } from '@aws-amplify/ui-react';
import React from 'react';
import { connect } from 'react-redux';
import { useRedirectURI } from '../../hooks/useRedirectURI';

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang
	};
};

const Register = (props) => {
	const { redirectURI } = useRedirectURI();

	const [email, setEmail] = React.useState('');
	const [name, setName] = React.useState('');
	const [surname, setSurname] = React.useState('');
	const [phone, setPhone] = React.useState('');
	const [password, setPassword] = React.useState('');

	const signInOnClick = () => {
		try {
			const authenticatorElement = document.getElementsByTagName(
				'amplify-authenticator'
			);
			const signUpElement =
				authenticatorElement[0].getElementsByTagName('amplify-sign-up');
			signUpElement[0].shadowRoot.querySelectorAll('button')[1].click();

			props.showSignUp(true);
		} catch (error) {
			console.error(error);
		}
	};

	React.useEffect(() => {
		setEmail('');
		setName('');
		setSurname('');
		setPassword('');
		setPhone('');
	}, [props.lang]);

	return (
		<AmplifySignUp
			className="register"
			headerText=""
			usernameAlias="email"
			slot="sign-up"
			formFields={[
				{
					type: 'email',
					required: true,
					value: email,
					inputProps: {
						onChange: (e) => setEmail(e.target.value)
					}
				},
				{
					label: I18n.get('REGISTER_NAME_LABEL'),
					type: 'name',
					required: true,
					value: name,
					placeholder: I18n.get('REGISTER_NAME_PLACEHOLDER_LABEL'),
					inputProps: {
						onChange: (e) => setName(e.target.value)
					}
				},
				{
					label: I18n.get('REGISTER_SURNAME_LABEL'),
					type: 'family_name',
					required: true,
					value: surname,
					placeholder: I18n.get('REGISTER_SURNAME_PLACEHOLDER_LABEL'),
					inputProps: {
						onChange: (e) => setSurname(e.target.value)
					}
				},
				{
					type: 'password',
					required: true,
					value: password,
					minLength: 8,
					inputProps: {
						onChange: (e) => setPassword(e.target.value)
					}
				},
				{
					type: 'phone_number',
					required: false,
					value: phone,
					dialCode: '+39',
					inputProps: {
						onChange: (e) => setPhone(e.target.value)
					}
				},
				{
					type: 'locale',
					value: props.lang,
					inputProps: {
						type: 'hidden'
					}
				},
				{
					type: 'custom:redirect_uri',
					value: redirectURI,
					inputProps: {
						type: 'hidden'
					}
				}
				/**  Here an example of a custom attribute insertion:
				 *
				 * This assume that the custom field customer-type
				 * is defined in file amplify/backend/auth/amplifyIdentityBrokerAuth/amplifyIdentityBrokerAuth-cloudformation-template.yml
				 *
				 *         - Name: customer-type
				 *           Mutable: true
				 *           Required: false
				 *           AttributeDataType: String
				 *
				,{
					label: I18n.get("YOUR_LABEL"),
					type: "custom:customer-type",
					value: "anything",
					required: false,
				}
				*/
			]}
		>
			<div slot="secondary-footer-content">
				<span>
					{I18n.get(Translations.SIGN_UP_HAVE_ACCOUNT_TEXT)}
					<span
						onClick={signInOnClick}
						style={{
							backgroundColor: 'trasparent',
							border: 'none',
							color: 'var(--amplify-primary-color)',
							cursor: 'pointer',
							marginLeft: '0.1rem'
						}}
					>
						{I18n.get(Translations.SIGN_IN_TEXT)}
					</span>
				</span>
			</div>
		</AmplifySignUp>
	);
};

export default connect(mapStateToProps, {})(Register);
